<template>
  <v-tabs v-model="tabMenu">
    <v-tabs-slider color="primary"></v-tabs-slider>
    <v-tab @click="resetTab()">Commission Rate</v-tab>
    <v-tab v-show="commissionReviewTab" @click="resetTab(2)">{{ ids.commissionNo !== 'new' ? 'Commission Info / Overriding Agent List' : 'New Commission' }}</v-tab>
    <v-tab v-show="overridingAgtReviewTab" @click="resetTab(3)">{{ ids.ovrInter !== 'new' ? 'Overriding Agent Info / Risk Item List' : 'New Overriding Agent' }}</v-tab>
    <v-tab-item>
      <commission-list :fetchCommission="fetchCommission" :inter="inter" :interGroupCode="interGroupCode" @doReview="doReview" @doQuery="doQuery" @doNew="doCommissionNew"></commission-list>
    </v-tab-item>
    <v-tab-item v-show="commissionReviewTab">
      <v-card>
        <v-divider></v-divider>
        <v-card-text v-if="!this.ids.queryCommission">
          <v-container fluid grid-list-lg>
            <v-layout row wrap>
              <v-flex xs12>
                <message :messages="messages"></message>
              </v-flex>
              <v-flex xs6 v-if="!newCommission">
                <v-subheader class="queryLabel">{{labels.effDate}}</v-subheader>
                <div class="title">{{formatDate(commissionForm.effDate)}}</div>
              </v-flex>
              <v-flex xs6 v-else>
                <cal-picker :label="labels.effDate" v-model="commissionForm.effDate" :error-messages="errors.collect('effDate')" data-vv-name="effDate" :data-vv-as="labels.effDate" v-validate="'required'"></cal-picker>
              </v-flex>
              <v-flex xs6 v-if="!newCommission">
                <v-subheader class="queryLabel">{{labels.polType}}</v-subheader>
                <div class="title">{{commissionForm.polType}}</div>
              </v-flex>
              <v-flex xs6 v-else>
                <v-autocomplete :label="labels.polType" v-model="commissionForm.polType" :items="interPolTypeList" item-text="label" item-value="value" data-vv-name="polType" :data-vv-as="labels.polType" :error-messages="errors.collect('polType')" :disabled="!newCommission"></v-autocomplete>
              </v-flex>
              <v-flex xs6>
                <v-text-field :label="labels.commPct" v-model="commissionForm.commPct" :error-messages="errors.collect('commPct')" v-validate="'required|mask_decimal:3|mask_min_value:1|mask_max_value:100'" data-vv-name="commPct" :data-vv-as="labels.commPct" :disabled="commissionForm.void_"></v-text-field>
              </v-flex>
              <v-flex xs6>
                <v-checkbox :label="labels.protComm" v-model="commissionForm.protComm" :error-messages="errors.collect('protComm')" data-vv-name="protComm" :data-vv-as="labels.protComm" :disabled="commissionForm.void_"></v-checkbox>
              </v-flex>
              <v-flex xs6>
                <v-select :items="interGrossNetList" v-model="commissionForm.commGn" :label="labels.commGn" item-text="label" item-value="value" data-vv-name="commGn" :data-vv-as="labels.commGn" :error-messages="errors.collect('commGn')" :disabled="commissionForm.void_"></v-select>
              </v-flex>
              <v-flex xs6>
                <v-text-field :label="labels.discPct" v-model="commissionForm.discPct" :error-messages="errors.collect('discPct')" v-validate="'mask_decimal:3|mask_max_value:100'" data-vv-name="discPct" :data-vv-as="labels.discPct" :disabled="commissionForm.void_"></v-text-field>
              </v-flex>
              <v-flex xs6>
                <v-checkbox :label="labels.protDisc" v-model="commissionForm.protDisc" :error-messages="errors.collect('protDisc')" data-vv-name="protDisc" :data-vv-as="labels.protDisc" :disabled="commissionForm.void_"></v-checkbox>
              </v-flex>
              <v-flex xs6 v-if="commissionForm.void_">
                <v-checkbox :label="labels.void_" v-model="commissionForm.void_" :error-messages="errors.collect('void_')" data-vv-name="void_" :data-vv-as="labels.void_"></v-checkbox>
              </v-flex>
              <v-flex xs6 v-if="commissionForm.void_">
                <v-text-field :label="labels.voidReason" v-model="commissionForm.voidReason" :error-messages="errors.collect('voidReason')" v-validate="'required|max:200'" data-vv-name="voidReason" :data-vv-as="labels.voidReason"></v-text-field>
              </v-flex>
              <v-flex xs6>
              </v-flex>
              <v-flex xs6 v-if="!newCommission">
                <v-subheader class="queryLabel">{{labels.createdBy}}</v-subheader>
                <div class="title">{{createdBy}}</div>
              </v-flex>
              <v-flex xs6 v-if="!newCommission">
                <v-subheader class="queryLabel">{{labels.createdDate}}</v-subheader>
                <div class="title">{{formatDate(createdDate)}}</div>
              </v-flex>
              <v-flex xs6 v-if="!newCommission">
                <v-subheader class="queryLabel">{{labels.modifiedBy}}</v-subheader>
                <div class="title">{{modifiedBy}}</div>
              </v-flex>
              <v-flex xs6 v-if="!newCommission">
                <v-subheader class="queryLabel">{{labels.modifiedDate}}</v-subheader>
                <div class="title">{{formatDate(modifiedDate)}}</div>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-text v-else>
          <v-container fluid grid-list-lg>
            <v-layout row wrap>
              <v-flex xs12>
                <message :messages="messages"></message>
              </v-flex>
              <v-flex xs4>
                <v-subheader class="queryLabel">{{labels.effDate}}</v-subheader>
              </v-flex>
              <v-flex xs8>
                <div class="title">{{formatDate(commissionForm.effDate)}}</div>
              </v-flex>
              <v-flex xs4>
                <v-subheader class="queryLabel">{{labels.polType}}</v-subheader>
              </v-flex>
              <v-flex xs8>
                <div class="title">{{commissionForm.polType}}</div>
              </v-flex>
              <v-flex xs4>
                <v-subheader class="queryLabel">{{labels.commPct}}</v-subheader>
              </v-flex>
              <v-flex xs8>
                <div class="title">{{commissionForm.commPct}}</div>
              </v-flex>
              <v-flex xs4>
                <v-subheader class="queryLabel">{{labels.protComm}}</v-subheader>
              </v-flex>
              <v-flex xs8>
                <div class="title">{{formatBoolean(commissionForm.protComm)}}</div>
              </v-flex>
              <v-flex xs4>
                <v-subheader class="queryLabel">{{labels.commGn}}</v-subheader>
              </v-flex>
              <v-flex xs8>
                <div class="title">{{commissionForm.commGn}}</div>
              </v-flex>
              <v-flex xs4>
                <v-subheader class="queryLabel">{{labels.discPct}}</v-subheader>
              </v-flex>
              <v-flex xs8>
                <div class="title">{{commissionForm.discPct}}</div>
              </v-flex>
              <v-flex xs4>
                <v-subheader class="queryLabel">{{labels.protDisc}}</v-subheader>
              </v-flex>
              <v-flex xs8>
                <div class="title">{{formatBoolean(commissionForm.protDisc)}}</div>
              </v-flex>
              <v-flex xs4>
                <v-subheader class="queryLabel">{{labels.void_}}</v-subheader>
              </v-flex>
              <v-flex xs8>
                <div class="title">{{formatBoolean(commissionForm.void_)}}</div>
              </v-flex>
              <v-flex xs4>
                <v-subheader class="queryLabel">{{labels.voidReason}}</v-subheader>
              </v-flex>
              <v-flex xs8>
                <div class="title">{{commissionForm.voidReason}}</div>
              </v-flex>
              <v-flex xs4>
                <v-subheader class="queryLabel">{{labels.createdBy}}</v-subheader>
              </v-flex>
              <v-flex xs8>
                <div class="title">{{createdBy}}</div>
              </v-flex>
              <v-flex xs4>
                <v-subheader class="queryLabel">{{labels.createdDate}}</v-subheader>
              </v-flex>
              <v-flex xs8>
                <div class="title">{{formatDate(createdDate)}}</div>
              </v-flex>
              <v-flex xs4>
                <v-subheader class="queryLabel">{{labels.modifiedBy}}</v-subheader>
              </v-flex>
              <v-flex xs8>
                <div class="title">{{modifiedBy}}</div>
              </v-flex>
              <v-flex xs4>
                <v-subheader class="queryLabel">{{labels.modifiedDate}}</v-subheader>
              </v-flex>
              <v-flex xs8>
                <div class="title">{{formatDate(modifiedDate)}}</div>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-flex xs12 v-if="!this.ids.queryCommission">
          <v-btn color="primary" type="submit" :loading="submitting" @click.prevent="doSave">
            {{ newCommission ? 'Save Commission' : 'Update Commission' }}
            <v-icon right>{{newCommission ? 'mdi-plus' : 'mdi-content-save'}}</v-icon>
          </v-btn>
        </v-flex>
        <confirm v-model="promptEffDate" @cancel="doCancelEffDate" @ok="doCreate">
          Effective Date is a past date
        </confirm>
      </v-card>
      <!-- <commission-form :ids="ids" @resetTab="resetTab"></commission-form> -->
      <!-- <overriding-agt-list v-show="ids.commissionNo !== 'new'" :fetchOverridingAgt="fetchOverridingAgt" :ids="ids" @doReview="doOverridingAgtReview" @doQuery="doOverridingAgtQuery" @doNew="doOverridingAgtNew"></overriding-agt-list> -->
      <v-card v-show="ids.commissionNo !== 'new'">
    <v-flex xs12 v-if="messages">
      <message :messages="messages"></message>
    </v-flex>
    <v-card-title>
      <v-flex xs6>
        <div class="headline">Overriding Agent</div>
      </v-flex>
      <v-flex xs6>
        <v-text-field append-icon="mdi-magnify" label="Search" single-line hide-details v-model="search"></v-text-field>
      </v-flex>
      <v-spacer></v-spacer>
    </v-card-title>
    <v-data-table
      :headers="headers"
      :items="items"
      :search="search"
      :footer-props="{'items-per-page-options': itemsPerPage }"
      :options.sync="pagination"
      item-key="index"
      :loading="loading"
      :no-data-text="noDataText"
      :custom-filter="customSearch"
    >
      <template slot="headerCell" slot-scope="props">
        <v-tooltip bottom>
          <span v-on="on">
            {{ props.header.text }}
          </span>
          <span>
            {{ props.header.text }}
          </span>
        </v-tooltip>
      </template>
      <template v-slot:item="row">
        <tr>
          <td class="text-xs-left">{{ row.item.seqNo }}</td>
          <td class="text-xs-left">{{ row.item.ovrInter }}</td>
          <td class="text-xs-left">{{ formatBoolean(row.item.protect) }}</td>
          <td class="text-xs-left">{{ row.item.commGn }}</td>
          <td class="text-xs-left">{{ row.item.commPct }}</td>
          <td class="text-xs-left">{{ formatBoolean(row.item.void_) }}</td>
          <td class="table-action-header">
            <table-action :rowData="row" review @review="doOverridingAgtReview(row.item)" query @query="doOverridingAgtQuery(row.item)" remove @remove="doPromptRemove(row.item)"></table-action>
          </td>
        </tr>
      </template>
    </v-data-table>
    <v-checkbox :label="labels.voidTransaction" v-model="voidTransaction" v-on:change="getOvrAgtList()"></v-checkbox>
    <v-btn color="primary" dark class="mb-2" @click="doOverridingAgtNew">New Overriding Agent<v-icon>mdi-plus</v-icon></v-btn>
    <!-- <confirm v-model="promptRemove" @ok="doRemove">
      Are you sure that you want to delete the selected Overriding Agent?
      <div class="title">{{ deleteOvrInter }}</div>
    </confirm> -->
  </v-card>

    </v-tab-item>
    <v-tab-item v-if="commissionReviewTab">
      <v-card>
    <v-divider></v-divider>
    <v-card-text v-if="!this.ids.queryOvrAgt">
      <v-container fluid grid-list-lg>
        <v-layout row wrap>
          <v-flex xs12>
            <message :messages="messages"></message>
          </v-flex>
          <v-flex xs6>
            <v-subheader class="queryLabel">{{ovrAgtlabels.polType}}</v-subheader>
            <div class="title">{{ovrAgtForm.polType}}</div>
          </v-flex>
          <v-flex xs6>
            <v-subheader class="queryLabel">{{ovrAgtlabels.effDate}}</v-subheader>
            <div class="title">{{formatDate(ovrAgtForm.effDate)}}</div>
          </v-flex>
          <v-flex xs6 v-if="newOvrAgt">
            <v-autocomplete :label="ovrAgtlabels.ovrInter" v-model="ovrAgtForm.ovrInter" :items="interList" item-text="label" item-value="value" data-vv-name="ovrInter" :data-vv-as="labels.ovrInter" :error-messages="errors.collect('ovrInter')" v-validate="'required'"></v-autocomplete>
            <!-- <v-text-field :label="labels.ovrInter" v-model="ovrAgtForm.ovrInter" :error-messages="errors.collect('ovrInter')" v-validate="'required|max:8'" data-vv-name="ovrInter" :data-vv-as="labels.ovrInter"></v-text-field> -->
          </v-flex>
          <v-flex xs6 v-else>
            <v-subheader class="queryLabel">{{ovrAgtlabels.ovrInter}}</v-subheader>
            <div class="title">{{ovrAgtForm.ovrInter}}</div>
          </v-flex>
          <v-flex xs6>
            <v-checkbox :label="ovrAgtlabels.protect" v-model="ovrAgtForm.protect" :error-messages="errors.collect('protect')" data-vv-name="protect" :data-vv-as="labels.protect" :disabled="ovrAgtForm.void_"></v-checkbox>
          </v-flex>
          <v-flex xs6>
            <v-select :items="interGrossNetList" v-model="ovrAgtForm.commGN" :label="ovrAgtlabels.commGN" item-text="label" item-value="value" data-vv-name="commGN" :data-vv-as="labels.commGN" :error-messages="errors.collect('commGN')" :disabled="ovrAgtForm.void_"></v-select>
          </v-flex>
          <v-flex xs6>
            <v-text-field :label="ovrAgtlabels.commPct" v-model="ovrAgtForm.commPct" :error-messages="errors.collect('commPct')" v-validate="'mask_decimal:3|mask_max_value:100'" data-vv-name="commPct" :data-vv-as="labels.commPct" :disabled="ovrAgtForm.void_"></v-text-field>
          </v-flex>
          <v-flex xs6 v-if="ovrAgtForm.void_">
            <v-checkbox :label="ovrAgtlabels.void_" v-model="ovrAgtForm.void_" :error-messages="errors.collect('void_')" data-vv-name="void_" :data-vv-as="labels.void_"></v-checkbox>
          </v-flex>
          <v-flex xs6 v-if="ovrAgtForm.void_">
            <v-text-field :label="ovrAgtlabels.voidReason" v-model="ovrAgtForm.voidReason" :error-messages="errors.collect('voidReason')" v-validate="'required|max:200'" data-vv-name="voidReason" :data-vv-as="labels.voidReason"></v-text-field>
          </v-flex>
          <v-flex xs6 v-if="!newOvrAgt">
            <v-subheader class="queryLabel">{{ovrAgtlabels.createdBy}}</v-subheader>
            <div class="title">{{createdBy}}</div>
          </v-flex>
          <v-flex xs6 v-if="!newOvrAgt">
            <v-subheader class="queryLabel">{{ovrAgtlabels.createdDate}}</v-subheader>
            <div class="title">{{formatDate(createdDate)}}</div>
          </v-flex>
          <v-flex xs6 v-if="!newOvrAgt">
            <v-subheader class="queryLabel">{{ovrAgtlabels.modifiedBy}}</v-subheader>
            <div class="title">{{modifiedBy}}</div>
          </v-flex>
          <v-flex xs6 v-if="!newOvrAgt">
            <v-subheader class="queryLabel">{{ovrAgtlabels.modifiedDate}}</v-subheader>
            <div class="title">{{formatDate(modifiedDate)}}</div>
          </v-flex>
        </v-layout>
      </v-container>
    </v-card-text>
    <v-card-text v-else>
      <v-container fluid grid-list-lg>
        <v-layout row wrap>
          <v-flex xs12>
            <message :messages="messages"></message>
          </v-flex>
          <v-flex xs4>
            <v-subheader class="queryLabel">{{ovrAgtlabels.polType}}</v-subheader>
          </v-flex>
          <v-flex xs8>
            <div class="title">{{ovrAgtForm.polType}}</div>
          </v-flex>
          <v-flex xs4>
            <v-subheader class="queryLabel">{{ovrAgtlabels.effDate}}</v-subheader>
          </v-flex>
          <v-flex xs8>
            <div class="title">{{formatDate(ovrAgtForm.effDate)}}</div>
          </v-flex>
          <v-flex xs4>
            <v-subheader class="queryLabel">{{ovrAgtlabels.ovrInter}}</v-subheader>
          </v-flex>
          <v-flex xs8>
            <div class="title">{{ovrAgtForm.ovrInter}}</div>
          </v-flex>
          <v-flex xs4>
            <v-subheader class="queryLabel">{{ovrAgtlabels.protect}}</v-subheader>
          </v-flex>
          <v-flex xs8>
            <div class="title">{{formatBoolean(ovrAgtForm.protect)}}</div>
          </v-flex>
          <v-flex xs4>
            <v-subheader class="queryLabel">{{ovrAgtlabels.commGN}}</v-subheader>
          </v-flex>
          <v-flex xs8>
            <div class="title">{{ovrAgtForm.commGN}}</div>
          </v-flex>
          <v-flex xs4>
            <v-subheader class="queryLabel">{{ovrAgtlabels.commPct}}</v-subheader>
          </v-flex>
          <v-flex xs8>
            <div class="title">{{ovrAgtForm.commPct}}</div>
          </v-flex>
          <v-flex xs4>
            <v-subheader class="queryLabel">{{ovrAgtlabels.void_}}</v-subheader>
          </v-flex>
          <v-flex xs8>
            <div class="title">{{formatBoolean(ovrAgtForm.void_)}}</div>
          </v-flex>
          <v-flex xs4>
            <v-subheader class="queryLabel">{{ovrAgtlabels.voidReason}}</v-subheader>
          </v-flex>
          <v-flex xs8>
            <div class="title">{{ovrAgtForm.voidReason}}</div>
          </v-flex>
          <v-flex xs4>
            <v-subheader class="queryLabel">{{ovrAgtlabels.createdBy}}</v-subheader>
          </v-flex>
          <v-flex xs8>
            <div class="title">{{createdBy}}</div>
          </v-flex>
          <v-flex xs4>
            <v-subheader class="queryLabel">{{ovrAgtlabels.createdDate}}</v-subheader>
          </v-flex>
          <v-flex xs8>
            <div class="title">{{formatDate(createdDate)}}</div>
          </v-flex>
          <v-flex xs4>
            <v-subheader class="queryLabel">{{ovrAgtlabels.modifiedBy}}</v-subheader>
          </v-flex>
          <v-flex xs8>
            <div class="title">{{modifiedBy}}</div>
          </v-flex>
          <v-flex xs4>
            <v-subheader class="queryLabel">{{ovrAgtlabels.modifiedDate}}</v-subheader>
          </v-flex>
          <v-flex xs8>
            <div class="title">{{formatDate(modifiedDate)}}</div>
          </v-flex>
        </v-layout>
      </v-container>
    </v-card-text>
    <v-flex xs12 v-if="!this.ids.queryOvrAgt">
      <v-btn color="primary" type="submit" :loading="submitting" @click.prevent="doSaveGeneral">
        {{ newOvrAgt ? 'Save Overriding Agent' : 'Update Overriding Agent' }}
        <v-icon right>{{newOvrAgt ? 'mdi-plus' : 'mdi-content-save'}}</v-icon>
      </v-btn>
    </v-flex>
  </v-card>
      <!-- <overriding-agt-form :ids="ids" @resetTab="resetTab"></overriding-agt-form> -->
    </v-tab-item>
  </v-tabs>
</template>

<script>
import CommissionList from '../list/CommissionList'
// import OverridingAgtList from '../list/OverridingAgtList'
// import CommissionForm from '../form/CommissionForm'
import * as TableConst from '@/mixins/table'
// import OverridingAgtForm from '../form/OverridingAgtForm'
import { interGrossNet } from '@/const/underwriting'
import { expandURI } from '@/utils/ajax'
import { extractMenu } from '@/utils/extract'
import MessageMixin from '@/mixins/message'
import { formatDisplayDateTime, formatDisplayDate, formatDisplayDateTime3 } from '@/utils/date'

export default {
  data() {
    return {
      tabMenu: 0,
      commissionReviewTab: false,
      overridingAgtReviewTab: false,
      fetchCommission: false,
      fetchOverridingAgt: false,
      submitting: false,
      newCommission: false,
      interPolTypeList: [],
      createdBy: undefined,
      createdDate: undefined,
      modifiedBy: undefined,
      modifiedDate: undefined,
      promptEffDate: false,
      voidTransaction: false,
      newOvrAgt: false,
      promptRemove: false,
      interList: [],
      ids: {
        inter: null,
        interGroupCode: null,
        commissionNo: null,
        effDate: null,
        polType: null,
        queryCommission: null,
        ovrInter: null,
        queryOvrAgt: null
      },
      labels: {
        inter: 'Inter',
        effDate: 'Effective Date*',
        polType: 'Policy Type*',
        commPct: 'Rate %*',
        protComm: 'Protect Rate',
        commGn: 'Gross or Net',
        discPct: 'Discount %',
        protDisc: 'Protect Discount',
        void_: 'Void',
        voidReason: 'Void Reason',
        createdBy: 'Created by',
        createdDate: 'Created Date',
        modifiedBy: 'Modified by',
        modifiedDate: 'Modified Date',
        voidTransaction: 'Include void transactions'
      },
      ovrAgtlabels: {
        polType: 'Policy Type',
        effDate: 'Effective Date',
        ovrInter: 'Overriding Agent*',
        protect: 'Protect Commission',
        commGN: 'Gross or Net',
        commPct: 'Rate %',
        void_: 'Void',
        voidReason: 'Void Reason',
        createdBy: 'Created by',
        createdDate: 'Created Date',
        modifiedBy: 'Modified by',
        modifiedDate: 'Modified Date'
      },
      commissionForm: {
        inter: null,
        effDate: null,
        polType: null,
        commPct: 0,
        protComm: false,
        commGn: 'G',
        discPct: 0,
        protDisc: false,
        void_: null,
        voidReason: null
      },
      ovrAgtForm: {
        inter: null,
        polType: null,
        effDate: null,
        ovrInter: null,
        protect: false,
        commGN: 'G',
        commPct: 0,
        void_: null,
        voidReason: null
      },
      headers: [
        { text: 'Sequence', value: 'seqNo' },
        { text: 'Overriding Agent', value: 'ovrInter' },
        { text: 'Protect', value: 'protect' },
        { text: 'Gross/Net', value: 'commGN' },
        { text: 'Rate%', value: 'commPct' },
        { text: 'Void', value: 'void_' },
        TableConst.tableActionHeader
      ],
      deleteVoid: false
    }
  },
  computed: {
    // schemeMenu() {
    //   return this.$store.state.parameters.scheme.schemeMenu
    // },
    interGrossNetList() {
      let result = []
      Object.keys(interGrossNet).forEach(function(key) {
        const status = interGrossNet[key]
        result.push({
          label: status,
          value: key
        })
      })
      return result
    }
  },
  methods: {
    async resetTab(tab) {
      switch (tab) {
        case 4: {
          this.tabMenu = 3
          this.commissionReviewTab = true
          this.overridingAgtReviewTab = true
          this.fetchCommission = false
          this.fetchOverridingAgt = false
          break
        }
        case 3: {
          this.tabMenu = 2
          this.commissionReviewTab = true
          this.overridingAgtReviewTab = true
          this.fetchCommission = false
          this.fetchOverridingAgt = false
          break
        }
        case 2: {
          await this.getOvrAgtList()
          if (this.deleteVoid) {
            this.ovrAgtForm.void_ = false
          }
          this.deleteVoid = false
          this.tabMenu = 1
          this.ids.ovrInter = null
          this.commissionReviewTab = true
          this.overridingAgtReviewTab = false
          this.fetchCommission = false
          this.fetchOverridingAgt = true
          break
        }
        default: {
          this.tabMenu = 0
          this.ids.commissionNo = null
          this.ids.effDate = null
          this.ids.polType = null
          this.ids.queryCommission = false
          this.ids.queryOvrAgt = false
          this.commissionReviewTab = false
          this.overridingAgtReviewTab = false
          this.fetchCommission = true
          this.fetchOverridingAgt = false
          this.newCommission = false
        }
      }
    },
    doCommissionReview(data) {
      this.ids.inter = this.inter
      this.ids.commissionNo = data.commissionNo
      this.ids.effDate = data.effDateTime
      this.ids.polType = data.polType
      this.ids.queryCommission = false
      this.commissionReviewTab = true
      this.fetchCommission = false
      this.fetchOverridingAgt = true
      this.tabMenu = 1
    },
    doCommissionQuery(data) {
      this.ids.inter = this.inter
      this.ids.commissionNo = data.commissionNo
      this.ids.effDate = data.effDateTime
      this.ids.polType = data.polType
      this.ids.queryCommission = true
      this.commissionReviewTab = true
      this.fetchCommission = false
      this.fetchOverridingAgt = true
      this.tabMenu = 1
    },
    async doCommissionNew() {
      await this.getInterPolTypeList()
      this.ids.inter = this.inter
      this.ids.commissionNo = 'new'
      this.commissionReviewTab = true
      this.fetchCommission = false
      this.fetchOverridingAgt = false
      this.tabMenu = 1
      this.newCommission = true
      this.commissionForm.inter = this.inter
      this.commissionForm.effDate = null
      this.commissionForm.polType = null
      this.commissionForm.commPct = 0
      this.commissionForm.protComm = false
      this.commissionForm.commGn = 'G'
      this.commissionForm.discPct = 0
      this.commissionForm.protDisc = false
      this.commissionForm.void_ = null
      this.commissionForm.voidReason = null
    },
    async doOverridingAgtReview(data) {
      this.ids.inter = data.inter
      this.ids.commissionNo = data.commissionNo
      this.ids.ovrInter = data.ovrInter
      this.ids.queryOvrAgt = false
      this.ovrAgtForm.polType = this.commissionForm.polType
      this.ovrAgtForm.effDate = this.commissionForm.effDate
      this.ovrAgtForm.inter = this.commissionForm.inter
      this.ovrAgtForm.seqNo = data.seqNo
      this.ovrAgtForm.ovrInter = data.ovrInter
      this.ovrAgtForm.protect = data.protect
      this.ovrAgtForm.commGn = data.commGn
      this.ovrAgtForm.commPct = data.commPct
      this.ovrAgtForm.void_ = data.void_
      this.ovrAgtForm.voidReason = data.voidReason
      this.newOvrAgt = false
      this.commissionReviewTab = true
      this.overridingAgtReviewTab = true
      this.fetchCommission = false
      this.fetchOverridingAgt = false
      this.tabMenu = 2
    },
    async doOverridingAgtReviewVoid(data) {
      this.ids.inter = data.inter
      this.ids.commissionNo = data.commissionNo
      this.ids.ovrInter = data.ovrInter
      this.ids.queryOvrAgt = false
      this.ovrAgtForm.polType = this.commissionForm.polType
      this.ovrAgtForm.effDate = this.commissionForm.effDate
      this.ovrAgtForm.inter = this.commissionForm.inter
      this.ovrAgtForm.seqNo = data.seqNo
      this.ovrAgtForm.ovrInter = data.ovrInter
      this.ovrAgtForm.protect = data.protect
      this.ovrAgtForm.commGn = data.commGn
      this.ovrAgtForm.commPct = data.commPct
      this.ovrAgtForm.void_ = true
      this.ovrAgtForm.voidReason = data.voidReason
      this.newOvrAgt = false
      this.commissionReviewTab = true
      this.overridingAgtReviewTab = true
      this.fetchCommission = false
      this.fetchOverridingAgt = false
      this.tabMenu = 2
    },
    async doOverridingAgtQuery(data) {
      this.ids.inter = data.inter
      this.ids.commissionNo = data.commissionNo
      this.ids.ovrInter = data.ovrInter
      this.ids.queryOvrAgt = true
      this.ovrAgtForm.polType = this.commissionForm.polType
      this.ovrAgtForm.effDate = this.commissionForm.effDate
      this.ovrAgtForm.inter = this.commissionForm.inter
      this.ovrAgtForm.seqNo = data.seqNo
      this.ovrAgtForm.ovrInter = data.ovrInter
      this.ovrAgtForm.protect = data.protect
      this.ovrAgtForm.commGn = data.commGn
      this.ovrAgtForm.commPct = data.commPct
      this.ovrAgtForm.void_ = data.void_
      this.newOvrAgt = false
      // await this.doGetOvrAgt(data.ovrInter)
      this.commissionReviewTab = true
      this.overridingAgtReviewTab = true
      this.fetchCommission = false
      this.fetchOverridingAgt = false
      this.tabMenu = 2
    },
    doOverridingAgtNew() {
      this.ids.ovrInter = 'new'
      this.commissionReviewTab = true
      this.overridingAgtReviewTab = true
      this.fetchCommission = false
      this.fetchOverridingAgt = false
      this.newOvrAgt = true
      this.ids.queryOvrAgt = false
      this.ovrAgtForm.polType = this.commissionForm.polType
      this.ovrAgtForm.effDate = this.commissionForm.effDate
      this.ovrAgtForm.inter = this.commissionForm.inter
      this.ovrAgtForm.ovrInter = null
      this.ovrAgtForm.protect = false
      this.ovrAgtForm.commGn = 'G'
      this.ovrAgtForm.commPct = 0
      this.ovrAgtForm.void_ = null
      this.ovrAgtForm.voidReason = null
      this.tabMenu = 2
    },
    async doReview(data) {
      this.submitting = true
      this.ids.inter = this.inter
      this.ids.commissionNo = data.commissionNo
      this.ids.effDate = data.effDateTime
      this.ids.polType = data.polType
      this.ids.queryCommission = false
      this.fetchCommission = false
      await this.doGetDetails()
      await this.getInterList()
      await this.getOvrAgtList()
      await this.getInterPolTypeList()
      this.commissionReviewTab = true
      this.fetchOverridingAgt = true
      this.tabMenu = 1
      this.submitting = false
    },
    async getInterList() {
      const apiURI = this.menu.interList
      try {
        const result = await this.$http.get(apiURI)
        const { data } = result.data
        if (data) {
          this.interList = data
        }
      } catch (err) {
        throw err
      }
    },
    async doQuery(data) {
      this.ids.inter = this.inter
      this.ids.commissionNo = data.commissionNo
      this.ids.effDate = data.effDateTime
      this.ids.polType = data.polType
      this.ids.queryCommission = true
      this.commissionReviewTab = true
      this.fetchCommission = false
      this.fetchOverridingAgt = true
      this.tabMenu = 1
      await this.doGetDetails()
      await this.getOvrAgtList()
    },
    async doGetDetails() {
      this.commissionForm.inter = this.ids.inter
      this.commissionForm.effDate = this.ids.effDate
      this.commissionForm.polType = this.ids.polType
      if (!this.newCommission) {
        const apiURI = this.$store.state.adminInter.intermediary.menu.getCommission
        // const apiURI = this.schemeMenu.menu.pkgPlan
        if (apiURI) {
          try {
            this.submitting = true
            const expand = {
              inter: this.ids.inter,
              effDate: formatDisplayDateTime3(this.ids.effDate),
              polType: this.ids.polType
            }
            const result = await this.$http.get(expandURI(apiURI, expand))
            const { data } = result.data
            if (data) {
              this.commissionForm.commPct = data.commission.commPct
              this.commissionForm.protComm = data.commission.protComm
              if (data.commission.commGn === 'Gross') {
                this.commissionForm.commGn = 'G'
              } else if (data.commission.commGn === 'Net') {
                this.commissionForm.commGn = 'N'
              }
              // this.commissionForm.commGn = data.commission.commGn
              this.commissionForm.discPct = data.commission.discPct
              this.commissionForm.protDisc = data.commission.protDisc
              this.commissionForm.void_ = data.commission.void_
              this.commissionForm.voidReason = data.commission.voidReason
              this.createdDate = data.commission.createdDate
              this.modifiedDate = data.commission.modifiedDate

              this.createdBy = data.strCreatedBy
              this.modifiedBy = data.strModifiedBy

              this.menu = extractMenu(result.data._links)
              this.submitting = false
            } else {
              this.submitting = false
              this.errorMessage('Fail to load Data from server. Please try to refresh page')
            }
          } catch (error) {
            this.submitting = false
            const { data } = error.response
            if (data) {
              this.message(data)
              this.fieldMessage(data)
            }
          }
        } else {
          this.errorMessage('The request failed because it is trying to execute an invalid API url. - Package Plan Form')
        }
      }
    },
    async getOvrAgtList() {
      if (!this.voidTransaction) {
        const apiURI = this.menu.ovrAgtList
        if (apiURI) {
          const expand = {
            inter: this.ids.inter,
            effDate: formatDisplayDateTime3(this.ids.effDate),
            polType: this.ids.polType
            // commissionNo: commissionNo
          }
          try {
            const result = await this.$http.get(expandURI(apiURI, expand))
            const { data } = result.data
            if (data) {
              this.items = []
              data.map((ovrAgt) => {
                const convertOvrAgt = {
                  seqNo: ovrAgt.seqNo,
                  inter: ovrAgt.inter,
                  ovrInter: ovrAgt.ovrInter,
                  protect: ovrAgt.protect,
                  commGn: ovrAgt.commGn,
                  commPct: ovrAgt.commPct,
                  commType: ovrAgt.commType,
                  void_: ovrAgt.void_,
                  voidReason: ovrAgt.voidReason
                }
                this.items.push(convertOvrAgt)
              })
              this.loading = false
            } else {
              this.loading = false
              this.items = []
            }
          } catch (error) {
            const { data } = error
            if (data) {
              this.message(data)
              this.fieldMessage(data)
              this.loading = false
            }
          }
        } else {
          this.loading = false
          this.errorMessage('The request failed because it is trying to execute an invalid API url. - Overriding Agent List')
          this.items = []
        }
      } else {
        const apiURI = this.menu.ovrAgtList2
        if (apiURI) {
          const expand = {
            inter: this.ids.inter,
            effDate: formatDisplayDateTime3(this.ids.effDate),
            polType: this.ids.polType
            // commissionNo: commissionNo
          }
          try {
            const result = await this.$http.get(expandURI(apiURI, expand))
            const { data } = result.data
            if (data) {
              this.items = []
              data.map((ovrAgt) => {
                const convertOvrAgt = {
                  seqNo: ovrAgt.seqNo,
                  inter: ovrAgt.inter,
                  ovrInter: ovrAgt.ovrInter,
                  protect: ovrAgt.protect,
                  commGn: ovrAgt.commGn,
                  commPct: ovrAgt.commPct,
                  commType: ovrAgt.commType,
                  void_: ovrAgt.void_,
                  voidReason: ovrAgt.voidReason
                }
                this.items.push(convertOvrAgt)
              })
              this.loading = false
            } else {
              this.loading = false
              this.items = []
            }
          } catch (error) {
            const { data } = error
            if (data) {
              this.message(data)
              this.fieldMessage(data)
              this.loading = false
            }
          }
        } else {
          this.loading = false
          this.errorMessage('The request failed because it is trying to execute an invalid API url. - Overriding Agent List')
          this.items = []
        }
      }
    },
    async getInterPolTypeList() {
      const apiURI = this.$store.state.adminInter.intermediary.menu.polTypeList
      try {
        const result = await this.$http.get(apiURI)
        const { data } = result.data
        if (data) {
          this.interPolTypeList = data
        }
      } catch (err) {
        throw err
      }
    },
    async doSaveGeneral() {
      this.resetMessages()
      this.$validator.validateAll().then(result => {
        if (result) {
          if (this.newOvrAgt) {
            this.doCreateGeneral()
          } else if (this.deleteVoid) {
            this.doRemove()
          } else {
            this.doUpdateGeneral()
          }
        } else {
          this.promptFieldCheck()
        }
      })
    },
    async doCreateGeneral() {
      try {
        const apiURI = this.menu.createOvrAgt
        if (apiURI) {
          const formatForm = {
            inter: this.ovrAgtForm.inter,
            polType: this.ovrAgtForm.polType,
            effDate: this.ovrAgtForm.effDate,
            ovrInter: this.ovrAgtForm.ovrInter,
            protect: this.ovrAgtForm.protect,
            commGN: this.ovrAgtForm.commGN,
            commPct: parseFloat(this.ovrAgtForm.commPct)
          }
          const result = await this.$http.post(apiURI, formatForm)
          const { data } = result
          if (data) {
            this.notify(data)
            this.resetTab(2)
          }
        }
      } catch (error) {
        const { data } = error.response
        if (data) {
          this.message(data)
          this.fieldMessage(data)
        }
      }
    },
    async doUpdateGeneral() {
      const apiURI = this.menu.updateOvrAgt
      if (apiURI) {
        try {
          const formatForm = {
            inter: this.ovrAgtForm.inter,
            polType: this.ovrAgtForm.polType,
            effDate: this.ovrAgtForm.effDate,
            ovrInter: this.ovrAgtForm.ovrInter,
            protect: this.ovrAgtForm.protect,
            commGN: this.ovrAgtForm.commGN,
            commPct: parseFloat(this.ovrAgtForm.commPct),
            voidReason: this.ovrAgtForm.voidReason,
            void_: this.ovrAgtForm.void_
          }
          const result = await this.$http.put(apiURI, formatForm)
          const { data } = result
          if (data) {
            this.notify(data)
            this.deleteVoid = false
            this.resetTab(2)
          }
        } catch (error) {
          const { data } = error.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
      } else {
        this.errorMessage('The request failed because it is trying to execute an invalid API url. - Overriding Agent Update')
      }
    },
    async doSave() {
      this.resetMessages()
      this.$validator.validateAll().then(result => {
        if (result) {
          if (this.newCommission) {
            // if (removeTime(this.commissionForm.effDate) < removeTime(new Date())) {
            //   this.promptEffDate = true
            // } else {
            //   this.doCreate()
            // }
            this.doCreate()
          } else {
            this.doUpdate()
          }
        } else {
          this.promptFieldCheck()
        }
      })
    },
    async doCreate() {
      const apiURI = this.$store.state.adminInter.intermediary.menu.createCommission
      if (apiURI) {
        try {
          const formatForm = {
            inter: this.commissionForm.inter,
            effDate: this.commissionForm.effDate,
            polType: this.commissionForm.polType,
            commPct: parseFloat(this.commissionForm.commPct),
            protComm: this.commissionForm.protComm,
            commGn: this.commissionForm.commGn,
            discPct: parseFloat(this.commissionForm.discPct),
            protDisc: this.commissionForm.protDisc
          }
          const result = await this.$http.post(apiURI, formatForm)
          const { data } = result
          if (data) {
            this.notify(data)
            this.resetTab()
          }
        } catch (error) {
          const { data } = error.response
          if (data) {
            this.notify(data)
            this.fieldMessage(data)
          }
        }
      } else {
        this.errorMessage('The request failed because it is trying to execute an invalid API url. - Commission Create')
      }
    },
    removeFormatDate(date) {
      if (date === null) {
        return null
      } else if (date === undefined) {
        return null
      } else if (date === '') {
        return null
      } else {
        var dateString = date
        var dateParts = dateString.split('/')
        return new Date(dateParts[2], dateParts[1] - 1, dateParts[0])
      }
    },
    formatDate(xDate) {
      if (xDate === null) {
        return undefined
      } else {
        return formatDisplayDate(xDate)
      }
    },
    formateDateTime(dateTime) {
      return formatDisplayDateTime(dateTime)
    },
    formatBoolean(bool) {
      if (bool) {
        return 'Yes'
      } else {
        return 'No'
      }
    },
    async doUpdate() {
      const apiURI = this.menu.updateCommission
      if (apiURI) {
        try {
          const formatForm = {
            inter: this.commissionForm.inter,
            effDate: this.commissionForm.effDate,
            polType: this.commissionForm.polType,
            commPct: parseFloat(this.commissionForm.commPct),
            protComm: this.commissionForm.protComm,
            commGn: this.commissionForm.commGn,
            discPct: parseFloat(this.commissionForm.discPct),
            protDisc: this.commissionForm.protDisc,
            voidReason: this.commissionForm.voidReason,
            void_: this.commissionForm.void_
          }
          const result = await this.$http.put(apiURI, formatForm)
          const { data } = result
          if (data) {
            this.notify(data)
            this.resetTab()
          }
        } catch (error) {
          const { data } = error.message
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
      } else {
        this.errorMessage('The request failed because it is trying to execute an invalid API url. - Commission Update')
      }
    },
    doClearForm() {
      this.resetValidator()
      this.resetMessages()
      this.commissionForm.inter = this.ids.inter
      this.commissionForm.effDate = null
      this.commissionForm.polType = null
      this.commissionForm.commPct = 0
      this.commissionForm.protComm = false
      this.commissionForm.commGn = 'G'
      this.commissionForm.discPct = 0
      this.commissionForm.protDisc = false
      this.commissionForm.void_ = null
      this.commissionForm.voidReason = null
      this.createdDate = null
      this.modifiedDate = null
      this.createdBy = null
      this.modifiedBy = null
    },
    async doCancelEffDate() {
      this.commissionForm.effDate = new Date()
    },
    doPromptRemove(data) {
      if (data) {
        this.deleteVoid = true
        this.ovrAgtForm.void_ = true
        this.doOverridingAgtReviewVoid(data)
        // this.promptRemove = true
        this.selectedOvrInter = data
        // this.deleteOvrInter = data.ovrInter
      }
    },
    async doRemove() {
      const apiURI = this.menu.updateOvrAgtVoid
      if (apiURI) {
        this.loading = true
        const formatForm = {
          inter: this.ovrAgtForm.inter,
          effDate: this.ovrAgtForm.effDate,
          polType: this.ovrAgtForm.polType,
          ovrInter: this.ovrAgtForm.ovrInter,
          void_: true,
          voidReason: this.ovrAgtForm.voidReason
        }
        try {
          const result = await this.$http.put(apiURI, formatForm)
          this.notify(result.data)
          this.deleteVoid = false
          // Reinit
          // const formatForm2 = {
          //   inter: this.ids.inter,
          //   effDate: formatDisplayDateTime3(this.ids.effDate),
          //   polType: this.ids.polType,
          //   ovrInter: this.selectedOvrInter.ovrInter
          // }
          // this.$emit('doReview', formatForm2)
          this.resetTab()
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
          }
          this.loading = false
        }
      } else {
        this.$toast.error('The request failed because it is trying to execute an invalid API url. - Delete Overriding Agent')
      }
    }
  },
  components: {
    CommissionList
    // CommissionForm,
    // OverridingAgtList,
    // OverridingAgtForm
  },
  mixins: [
    TableConst.default,
    MessageMixin
  ],
  props: {
    inter: {
      type: String,
      default: ''
    },
    interGroupCode: {
      type: String,
      default: ''
    }
  }
}
</script>

<style>

</style>
